export function productCustomGallery() {
  let main = new window.splide('.splidePrimary', {
    type: 'fade',
    rewind: true,
    pagination: false,
    arrows: false,
  });

  let thumbnails = new window.splide('.splideNav', {
    perPage: 4,
    gap: '8px',
    rewind: true,
    pagination: false,
    isNavigation: true,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        perPage: 5,
        gap: '16px',
      },
      992: {
        perPage: 4,
      },
      1225: {
        perPage: 5,
      },
    }
  });

  thumbnails.on('overflow', function (isOverflow) {
    if (!isOverflow) {
      thumbnails.go(0);

      thumbnails.options = {
        arrows: isOverflow,
        pagination: isOverflow,
        drag: isOverflow,
        clones: isOverflow ? undefined : 0,
      };
    }
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();

  productLightboxEl = new window.lightbox({
    elements: '.lightBoxRun'
  });
}